/* eslint-disable react/prop-types */
import classes from "./composed-view-detail.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import * as announcementHelper from "@/common/announcement-helper";
import classNames from "classnames";
import MoreInfos from "./more-infos";
function ComposedViewDetail({
  title,
  status,
  image,
  promoting,
  cities,
  beneficiary,
  maxContribution,
  outgoings,
  types,
  granted,
  notes,
  pdf,
  onPdfClick,
  interventions,
  facilitation,
  incentive,
  className,
  dateLabel,
  date,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Flex
      align={isMobile ? "center" : "flex-start"}
      direction="column"
      justify={isMobile ? "center" : "flex-start"}
      className={classNames(classes.container, className)}
    >
      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>
      <Grid columns={isMobile ? "1fr" : "1fr 1fr"} className={classes.main}>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.subContainerLeft}
        >
          <Label
            weight="bold"
            align="start"
            size="sm"
            color="secondary"
            className={classNames(classes.status, {
              [classes.closed]: status === announcementHelper.Status.CLOSED,
              [classes.opened]: status === announcementHelper.Status.OPEN,
              [classes.reporting]:
                status === announcementHelper.Status.REPORTING,
              [classes.activating]:
                status === announcementHelper.Status.ACTIVATING,
            })}
          >
            Stato bando: {status}
          </Label>
          <Grid columns="1fr 1fr" className={classes.rowDetailDate}>
            <Label tag="p" size="sm" color="secondary" align="start">
              {dateLabel}
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {date}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Ente promotore:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {promoting ? promoting : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Area geografica:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {cities}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Beneficiari:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {beneficiary
                ? beneficiary
                : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Spese finanziate:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {outgoings ? outgoings : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Tipologia agevolazione:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {types ? types : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Agevolazione prevista:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {granted ? granted : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="secondary" align="start">
              Massimo contributo ottenibile:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="secondary"
              align="start"
              weight="bold"
            >
              {maxContribution
                ? maxContribution
                : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.subContainerRight)}
        >
          {!isMobile && (
            <img
              src={image ? image : announcementHelper.PLACEHOLDER}
              alt="Logo"
              className={classes.image}
            />
          )}
        </Flex>
      </Grid>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.notes}
      >
        <Label
          weight="bold"
          tag="h6"
          color="secondary"
          align="start"
          className={classes.title}
        >
          Note importanti:
        </Label>
        <Label color="secondary" align="start">
          {notes ? notes : announcementHelper.PROPERTY_PLACEHOLDER}
        </Label>
      </Flex>
      {pdf && (
        <Flex
          align="flex-start"
          direction="row"
          justify="flex-start"
          className={classes.pdf}
        >
          <Label
            color="secondary"
            align="start"
            weight="bold"
            onClick={onPdfClick}
          >
            DOWNLOAD REPORT TECNICO
          </Label>

          <img
            src={"/images/icons/cta-arrow.svg"}
            alt="pdf"
            className={classes.arrow}
            onClick={onPdfClick}
          />
        </Flex>
      )}
      <MoreInfos
        interventions={interventions}
        facilitation={facilitation}
        incentive={incentive}
        className={classes.moreInfos}
      />
    </Flex>
  );
}

export default ComposedViewDetail;
